var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6 tab",class:{'tab--active': _vm.active},on:{"click":function($event){return _vm.onClick()}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('span',{staticClass:"count"},[_vm._v("("+_vm._s(_vm.count)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }